function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_21_1430)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8 0C3.58867 0 0 3.58867 0 8C0 12.4113 3.58867 16 8 16C12.4113 16 16 12.4113 16 8C16 3.58867 12.4113 0 8 0ZM8 13C7.54 13 7.16667 12.6267 7.16667 12.1667C7.16667 11.7067 7.54 11.3333 8 11.3333C8.46 11.3333 8.83333 11.7067 8.83333 12.1667C8.83333 12.6267 8.46 13 8 13ZM9.792 8.20133C8.82933 9.01733 8.66667 9.31267 8.66667 9.66667C8.66667 10.0353 8.36867 10.3333 8 10.3333C7.63133 10.3333 7.33333 10.0353 7.33333 9.66667C7.33333 8.71067 7.87133 8.08067 8.93 7.184C9.228 6.93067 10.1593 6.03733 9.61267 5.15333C9.258 4.57933 7.93467 4.49733 6.838 4.98267C6.5 5.13133 6.10733 4.97867 5.95867 4.642C5.81 4.30533 5.96267 3.91133 6.29933 3.76267C7.85267 3.076 9.94133 3.14667 10.7473 4.45267C11.4827 5.642 11.1167 7.078 9.792 8.20067V8.20133Z",
  fill: "#5E5929"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_21_1430"
}, /*#__PURE__*/React.createElement("rect", {
  width: 16,
  height: 16,
  fill: "white"
})));

function SvgQuestionIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref, _ref2);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionIcon);
export default __webpack_public_path__ + "static/media/question_icon.822190d1.svg";
export { ForwardRef as ReactComponent };